import { useMutation } from 'react-query'
import axios from 'axios'

const postHotSwap = async data => {
    const response = await axios.post(`${process.env.API_URL}/hotswaps`, data)
    return response.data
}

const usePostHotSwap = () => {
    return useMutation(postHotSwap, {})
}

export default usePostHotSwap
